import { useCallback, useMemo } from 'react';
import { OrderSummary } from '../../../../types/sales.types';

export interface UseOrderInformationCardProps {
  orderSummary: OrderSummary;
}

export const useOrderInformationCard = ({ orderSummary }: UseOrderInformationCardProps) => {
  // Determinar color del estado de pago
  const getPaymentStatusColor = useCallback((status: string) => {
    switch (status) {
      case 'complete':
        return 'success';
      case 'partial':
        return 'warning';
      default:
        return 'error';
    }
  }, []);

  // Determinar texto del estado de pago
  const getPaymentStatusText = useCallback((status: string) => {
    switch (status) {
      case 'complete':
        return 'Pago Completo';
      case 'partial':
        return 'Pago Parcial';
      default:
        return 'Pendiente de Pago';
    }
  }, []);

  // Calcular valores para el estado actual
  const statusColor = useMemo(
    () => getPaymentStatusColor(orderSummary.paymentStatus),
    [orderSummary.paymentStatus, getPaymentStatusColor],
  );

  const statusText = useMemo(
    () => getPaymentStatusText(orderSummary.paymentStatus),
    [orderSummary.paymentStatus, getPaymentStatusText],
  );

  return {
    statusColor,
    statusText,
    getPaymentStatusColor,
    getPaymentStatusText,
  };
};
